import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreAppointment } from '@types';

const useGetAppointment = () => {
    const data = useStaticQuery(graphql`
        query AllAppointment {
            allPatstoreAppointment {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    date
    state
    description
    image
    
                    }
                }
            }
        }
    
        `);


    const allAppointment: PatstoreAppointment[] =
        data.allPatstoreAppointment.edges.map(
            (edge: { node: PatstoreAppointment }) => edge.node
        ) || [];

    const findAppointment: (id: string) => PatstoreAppointment | undefined = (id: string) => {
        const result = allAppointment.find((item: PatstoreAppointment) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findAppointment,
        appointments: allAppointment,
    };
}; 

export default useGetAppointment;
